// Generated by Melange

import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function NcaLayerUpdateModuleModal(Props) {
  let onClose = Props.onClose;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                    children: "Подписание документов"
                                  }),
                              JsxRuntime.jsx("button", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "w-6 h-6",
                                          src: StaticAsset.src("/static/icons/close.svg")
                                        }),
                                    onClick: (function (param) {
                                        Curry._1(onClose, undefined);
                                      })
                                  })
                            ],
                            className: "px-6 py-4 flex justify-between border-b border-gray-main w-full"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("img", {
                                    alt: "refresh",
                                    src: StaticAsset.src("/static/icons/refresh-blue-40.svg")
                                  }),
                              JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                                    className: "mt-6 text-center",
                                    children: "Обновите модуль \"Бухта\" в NCALayer"
                                  }),
                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                    className: "mt-2 text-asphalt text-center",
                                    children: "После обновления сможете подписать документы"
                                  })
                            ],
                            className: "flex flex-col items-center pt-10 pb-16 w-[320px]"
                          })
                    ],
                    className: "w-120 bg-white rounded shadow-payroll flex flex-col items-center"
                  }),
              className: "absolute inset-0 bg-black/40 flex justify-center items-center"
            });
}

const make = NcaLayerUpdateModuleModal;

export {
  make ,
}
/* Buhta_components__Text Not a pure module */
